import store from '../store'
import Login from '../views/Login.vue'
import PasswordReset from '../views/PasswordReset.vue'
import Base from '../views/Base'
import Home from '../views/Home.vue'
import Search from '../views/Search'
import CICS from '../views/CICS'
import AdminPanel from '../views/AdminPanel'
import StudyDetails from '../views/StudyDetails'
import FragranceProfile from '../views/FragranceProfile'
import StudyMapping from '../views/StudyMapping'
import StudyStatistics from '../views/StudyStatistics'
import UserList from '../views/UserList.vue'
import UserDetails from '../views/UserDetails.vue'
import FileStructure from '../views/FileStructure'
import searchRoutes from './searchRoutes'
import Analytics from '../views/Analytics'
import OpenEndedQuestionSearch from '../views/OpenEndedQuestionSearch.vue'
import ConceptProfile from '../views/ConceptProfile'
import StudiesUpload from '../views/StudiesUpload'
import RDFUpload from '../views/RDFUpload'
import RDFChoiceView from '@/components/RDFForms/RDFChoiceView'
import RDFSearch from '@/components/RDFForms/RDFSearch'
import StudiesUploadSecondStep
  from '@/components/StudiesUpload/StudiesUploadSecondStep'
import BulkExtract from '../views/BulkExtract'

const isAdministrator = (to, from, next) => {
  if (store.getters['GET_PERMISSIONS'].isAdmin) {
    next()
    return
  }
  next(from.path)
}

const canModifyUsers = (to, from, next) => {
  if (store.getters['GET_PERMISSIONS'].isAdmin) {
    next()
    return
  }
  next(from.path)
}

// Feature flag: Open Ended Question Search is hidden unless explicitly enabled
// (dev build sets VUE_APP_ENABLE_OPEN_ENDED=true; prod omits it → hidden). Gates
// both the route (here) and the nav link (Base.vue).
const OPEN_ENDED_ENABLED = process.env.VUE_APP_ENABLE_OPEN_ENDED === 'true'

export default {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Layout',
      redirect: '/home/',
      component: Base,
      meta: {
        title: 'Home - IRIS'
      },
      children: [
        {
          path: '/',
          name: 'home',
          meta: { auth: true, title: 'Home - IRIS' },
          component: Home
        },
        {
          path: '/admin',
          name: 'admin-panel',
          meta: { auth: true, title: 'Admin panel - IRIS' },
          component: AdminPanel,
          beforeEnter: isAdministrator
        },
        {
          path: '/users',
          name: 'user-list',
          meta: { auth: true, title: 'Users - IRIS' },
          component: UserList,
          beforeEnter: canModifyUsers
        },
        {
          path: '/users/add',
          name: 'add-user',
          meta: { auth: true, title: 'Add user - IRIS' },
          component: UserDetails,
          beforeEnter: canModifyUsers
        },
        {
          path: '/users/:id',
          name: 'user-page',
          meta: { auth: true, title: 'User details - IRIS' },
          component: UserDetails,
          beforeEnter: canModifyUsers
        },
        {
          path: '/users/:id/edit',
          name: 'edit-user',
          meta: { auth: true, title: 'Edit user - IRIS' },
          component: UserDetails,
          beforeEnter: canModifyUsers
        },
        {
          path: '/study/:id',
          name: 'study-details',
          meta: { auth: true, title: 'Study Details - IRIS' },
          component: StudyDetails
        },
        {
          path: '/study/:id/mapping',
          name: 'study-mapping',
          meta: { auth: true, title: 'Study Mapping - IRIS' },
          component: StudyMapping
        },
        {
          path: '/study/:id/statistics',
          name: 'study-statistics',
          meta: { auth: true, title: 'Study Statistics - IRIS' },
          component: StudyStatistics
        },
        {
          path: '/study/:id/structure',
          name: 'study-structure',
          meta: { auth: true, title: 'Study structure - IRIS' },
          component: FileStructure
        },
        {
          path: '/search',
          name: 'search',
          meta: { auth: true, title: 'Search - IRIS' },
          component: Search
        },
        {
          path: '/analytics',
          name: 'analytics',
          meta: { auth: true, title: 'Analytics - IRIS' },
          component: Analytics
        },
        {
          path: '/bulk-extract',
          name: 'bulk-extract',
          meta: { auth: true, title: 'Bulk Extract - IRIS' },
          component: BulkExtract
        },
        ...(OPEN_ENDED_ENABLED ? [{
          path: '/open-ended-question-search',
          name: 'open-ended-question-search',
          meta: { auth: true, title: 'Open Ended Question Search - IRIS' },
          component: OpenEndedQuestionSearch
        }] : []),
        {
          path: '/cics',
          name: 'cics',
          meta: { auth: true, title: 'CICS - IRIS' },
          component: CICS
        },
        {
          path: '/studies-upload',
          name: 'studies-upload',
          meta: { auth: true, title: 'Studies Upload' },
          component: StudiesUpload
        },
        {
          path: '/studies-upload/:id',
          name: 'studies-upload-details',
          meta: { auth: true, title: 'Verify Studies' },
          component: StudiesUploadSecondStep
        },
        {
          path: '/analytics/profile/:id/:code',
          name: 'fragrance-profile',
          meta: { auth: true, title: 'Fragrance profile - IRIS' },
          component: FragranceProfile,
          props: true
        },
        {
          path: '/analytics/concept/:id/:code',
          name: 'concept-profile',
          meta: { auth: true, title: 'Concept profile - IRIS' },
          component: ConceptProfile,
          props: true
        },
        {
          path: '/rdf_upload',
          name: 'rdf_upload',
          meta: { auth: true, title: 'Statistic Generator - IRIS' },
          component: RDFUpload
        },
        {
          path: '/rdf_upload/:id',
          name: 'rdf_upload_id',
          meta: { auth: true, title: 'Statistic Generator - IRIS' },
          component: RDFUpload
        },
        {
          path: '/rdf_search',
          name: 'rdf_search',
          meta: { auth: true, title: 'Statistic Generator - IRIS' },
          component: RDFSearch
        },
        {
          path: '/statistics-generator',
          name: 'statistics-generator',
          meta: { auth: true, title: 'Statistic Generator - IRIS' },
          component: RDFChoiceView
        },
        ...searchRoutes
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Login - IRIS'
      }
    },
    {
      path: '/login/reset',
      name: 'password-reset',
      component: PasswordReset,
      meta: {
        title: 'Reset password - IRIS'
      }
    },
    {
      path: '/login/reset/:token',
      name: 'password-reset-token',
      component: PasswordReset,
      meta: {
        title: 'Reset password - IRIS'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 250)
      })
    }
    return { x: 0, y: 0 }
  }
}
